





        // Define discount names, amounts, and announcements from Liquid settings
        const discounts = [
                
                {
                
                
                
                name: "FREEHYDRA",
                amount: 50,
                announcement: "✨ Code FREEHYDRA applied • Buy 2 Get 1 Free ✨"
                },
                
                {
                
                
                
                name: "STACK60",
                amount: 60,
                announcement: "✨ Code STACK60 applied • Save 60% Off Now ✨"
                },
                
                {
                
                
                
                
                amount: 0,
                
                },
                
                {
                
                
                
                
                amount: 0,
                
                },
                
                {
                
                
                
                
                amount: 0,
                
                },
                
                {
                
                
                
                
                amount: 0,
                
                },
                
                {
                
                
                
                
                amount: 0,
                
                },
                
                {
                
                
                
                
                amount: -4,
                
                },
                
                {
                
                
                
                
                amount: 0,
                
                },
                
                {
                
                
                
                
                amount: 60,
                
                },
                
                {
                
                
                
                name: "STAY55",
                amount: 55,
                announcement: "✨ Code STAY55 applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "SMOOTH55",
                amount: 55,
                announcement: "✨ Code SMOOTH55 applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "HYDRA55",
                amount: 55,
                announcement: "✨ Code HYDRA55 applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "EXCLUSIVE60",
                amount: 60,
                announcement: "✨ Code EXCLUSIVE60 applied • Save 60% Off Now ✨"
                },
                
                {
                
                
                
                name: "COMEBACK",
                amount: 55,
                announcement: "✨ Code COMEBACK applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "THANKYOU60",
                amount: 60,
                announcement: "✨ Code THANKYOU60 applied • Save 60% Off Now ✨"
                },
                
                {
                
                
                
                name: "SAVE55",
                amount: 55,
                announcement: "✨ Code SAVE55 applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "SAVE50",
                amount: 50,
                announcement: "✨ Code SAVE50 applied • Save 50% Off Now ✨"
                },
                
                {
                
                
                
                name: "VIP60",
                amount: 60,
                announcement: "✨ Code VIP60 applied • Save 60% Off Now ✨"
                },
                
                {
                
                
                
                name: "WELCOME55",
                amount: 55,
                announcement: "✨ Code WELCOME55 applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "GRATEFUL60",
                amount: 60,
                announcement: "✨ Code GRATEFUL60 applied • Save 60% Off Now ✨"
                },
                
                {
                
                
                
                name: "SAVE55NOW",
                amount: 55,
                announcement: "✨ Code SAVE55NOW applied • Save 60% Off Now ✨"
                },
                
                {
                
                
                
                name: "SEEYOU55",
                amount: 55,
                announcement: "✨ Code SEEYOU55 applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "MYVIP60",
                amount: 60,
                announcement: "✨ Code MYVIP60 applied • Save 60% Off Now ✨"
                },
                
                {
                
                
                
                name: "GET55OFF",
                amount: 55,
                announcement: "✨ Code GET55OFF applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "NUVE55",
                amount: 55,
                announcement: "✨ Code NUVE55 applied • Save 55% Off Now ✨"
                },
                
                {
                
                
                
                name: "SMOOTH60",
                amount: 60,
                announcement: "✨ Code SMOOTH60 applied • Save 60% Off Now ✨"
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                },
                
                {
                
                
                
                
                
                
                }
                
        ].filter(d => d.name); 

        // Define shipping discounts from Liquid settings
        const discounts_shipping = [
                { name: "shipsfree" },
                { name: "refills" },
                { name: "" },
                { name: "" },
                { name: "" }
        ].filter(d => d.name); 

        let activeDiscounts = [], discountFromCookie;

        function getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
        }

        function getStoredDiscounts(name) {
        const cookieValue = getCookie(name);
        const sessionValue = sessionStorage.getItem(name);

        if (cookieValue && !sessionValue) {
        sessionStorage.setItem(name, cookieValue);
        return cookieValue;
        }

        if (!cookieValue && sessionValue) {
        document.cookie = name + "=" + sessionValue + "; path=/; max-age=604800";
        return sessionValue;
        }

        return cookieValue || sessionValue || '';
        }

        // Check URL for discount codes (can be multiple)
        const params = new URLSearchParams(window.location.search);
        let discountFromQuery = params.getAll('discount')
        .map(d => d.split(','))
        .flat()
        .map(d => d.trim().toLowerCase())
        .filter(Boolean);

        /********** Product Discounts first **********/

        // If no discount in URL, Check Cookies for already stored discount code(s)
        // Else delete existing cookie to be replaced with new code(s) from URL
        if( discountFromQuery.length === 0 ) {
        discountFromCookie = (getStoredDiscounts('discount_code') || '')
        .split(',')
        .map(d => d.trim().toLowerCase())
        .filter(Boolean);
        }else{
        document.cookie = "discount_code=; path=/; max-age=0";
        sessionStorage.removeItem('discount_code');
        console.log("[Promo Tracker] URL discount code found, old cookie deleted.");
        }

        // Assign discountFromQuery priority over discountFromCookie
        // If we only have a product discount in the URL, use it. 
        // If we only have a Shipping discounts in the URL, no product discount is applied and free Shipping is applied further down
        // If we have both a product and shipping discount in the URL, Product discount is applied here and free Shipping is applied further down
        // If we have neither in the URL, use the discount(s) from the cookie if they exist

        let effectiveDiscounts = discountFromQuery.length > 0 ? discountFromQuery : discountFromCookie;

        // Find matching product discounts
        for (let i = 0; i < discounts.length; i++) {
        if (discounts[i].name && discounts[i].amount) {
                if (effectiveDiscounts.includes(discounts[i].name.toLowerCase())) {
                activeDiscounts.push({
                percent: discounts[i].amount,
                name: discounts[i].name,
                announcement: discounts[i].announcement
                });
                break;
                }
        }
        }

        // (Re)set cookie if we have active product discount
        if (activeDiscounts.length > 0) {
        const names = activeDiscounts.map(d => d.name).join(',');
        document.cookie = "discount_code=" + names + "; path=/; max-age=604800";
        sessionStorage.setItem('discount_code', names);
        console.log("[Promo Tracker] Found/Stored discount_code(s):", names);
        } else {
        console.log("[Promo Tracker] No discount code in URL.");
        }

        // Update announcement bar for the active product discount
        if (document.querySelector('.announcement-bar .announcement-bar__message') && activeDiscounts.length > 0) {
                activeDiscounts.forEach(d => {
                        if (d.announcement && d.announcement !== "null") {
                                document.querySelector('.announcement-bar .announcement-bar__message').innerText = d.announcement;
                                return;
                        } 
                });
        }


        /********** Then Shipping Discounts ********/

        // Check Cookies for already stored discount code(s)
        if( discountFromQuery.length === 0 ) {
        discountFromCookie = (getStoredDiscounts('discount_code_shipping') || '')
        .split(',')
        .map(d => d.trim().toLowerCase())
        .filter(Boolean);
        }else{
        document.cookie = "discount_code_shipping=; path=/; max-age=0";
        sessionStorage.removeItem('discount_code_shipping');
        console.log("[Promo Tracker] URL shipping discount code found, old cookie deleted.");
        }

        effectiveDiscounts = discountFromQuery.length > 0 ? discountFromQuery : discountFromCookie;

        let activeShippingDiscounts = [];

        // Find matching shipping discounts
        for (let i = 0; i < discounts_shipping.length; i++) {
        if (discounts_shipping[i].name) {
                if (effectiveDiscounts.includes(discounts_shipping[i].name.toLowerCase())) {
                activeShippingDiscounts.push({
                name: discounts_shipping[i].name,
                });
                break;
                }
        }
        }

        // (Re)set cookie if we have active shipping discount
        if (activeShippingDiscounts.length > 0) {
        const names = activeShippingDiscounts.map(d => d.name).join(',');
        document.cookie = "discount_code_shipping=" + names + "; path=/; max-age=604800";
        sessionStorage.setItem('discount_code_shipping', names);
        console.log("[Promo Tracker] Found/Stored discount_code_shipping:", names);
        } else {
        console.log("[Promo Tracker] No shipping code in URL.");
        }

